// # Warning flood component to generate copyright notices
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// # Create warning flood component
const WarningFlood = () => {
  const location = useLocation();

  // # Determine warning counts based on current page
  const isChapterPage = location.pathname.includes('/step1/') || location.pathname.includes('/step2/');
  // # Updated library page detection to be more accurate
  const isLibraryPage = location.pathname.includes('/library/step1') || location.pathname.includes('/library/step2') || 
                        location.pathname.includes('library_step_1') || location.pathname.includes('library_step_2');
  
  // # Updated initial warnings to 10000 for library pages
  const maxInitialWarnings = isChapterPage ? 1000 : isLibraryPage ? 10000 : 500;
  const secondWaveWarnings = isChapterPage ? 2000 : isLibraryPage ? 1000 : 1000;

  useEffect(() => {
    // # Initial burst of warnings with unique numbers - execute immediately
    const generateNumberedWarnings = (count, startIndex = 1) => {
      // # Use a synchronous loop to ensure warnings appear before any other code
      for(let i = startIndex; i < startIndex + count; i++) {
        console.warn(`Warning #${i}: This is a property of The Egyptian Mentorship Program for USMLE, protected by copyright laws`);
      }
    };

    // # Generate initial warnings immediately
    generateNumberedWarnings(maxInitialWarnings);

    // # Set up second wave of warnings after 1 second - reduced timing to precede Notion warnings
    const secondWaveTimer = setTimeout(() => {
      // # Start numbering from after the first wave
      generateNumberedWarnings(secondWaveWarnings, maxInitialWarnings + 1);
    }, 4000);

    // # Cleanup function
    return () => {
      clearTimeout(secondWaveTimer);
    };
  }, [maxInitialWarnings, secondWaveWarnings]);

  return null;
};

export default WarningFlood;
